<template>   
  <div>
    <div class="relative flex flex-row items-center justify-between">
      <slot name="parent-nav-link"></slot>
      <a class="w2 inline-flex pointer arrow-down-icon" :class="{ 'is-clicked': subNavMenuItemClicked }" @click="subNavMenuItemClicked = !subNavMenuItemClicked">
        <simple-svg :class="'white-arrow'"
          :filepath="'/uploads/plus.svg'"
          :id="'arrow-down-icon-id'">
        </simple-svg>
      </a>
    </div>
    <transition name="slide-fade-rev">
      <div class="relative pt3 is-tablet-regular" v-show="subNavMenuItemClicked">
        <slot name="sub-nav-links"></slot>
      </div>
    </transition>
  </div>
</template>

<script>
  export default {
    components: {
      //
    },
    data () {
      return {
        subNavMenuItemClicked: false,
      }
    },
    props: [],
    methods: {
      //
    }
  }
</script>